// Vendors
import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';

const RefinementList = ({ items, refine }) =>
  items.map((item) => (
    <div
      className={`facetwp-checkbox${item.isRefined ? ' checked' : ''}`}
      key={item.label}
      onClick={() => refine(item.value)}
    >
      {item.label} <span className="facetwp-counter">({item.count})</span>
    </div>
  ));

export default connectRefinementList(RefinementList);
